// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".svg-container[data-v-455f60cc]{padding-top:.8rem;padding-bottom:.8rem;position:absolute;top:0;bottom:0;margin:auto;width:1.6rem;height:3.2rem;left:2.6rem}.svg-container svg[data-v-455f60cc]{width:1.6rem;height:1.6rem}@media (min-width:1024px){.cart-title[data-v-455f60cc]{padding-left:4rem;font-size:26px;font-weight:600}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
